import { Level } from '../../domain/entities/Level';
import { Subject } from '../../domain/entities/Subject';
import { Assignment } from '../../domain/entities/Assignment';
import { LevelDTO } from '../dto/LevelDTO';
import { SubjectDTO } from '../dto/SubjectDTO';
import { AssignmentDTO } from '../dto/AssignmentDTO';

export class AcademicMapper {
  static levelToDTO(level: Level): LevelDTO {
    return {
      id: level.id,
      name: level.name,
      subjects: level.subjects,
      students: level.students,
    };
  }

  static levelToDomain(dto: LevelDTO): Level {
    return new Level({
      id: dto.id,
      workspaceId: 0, // Not available in DTO
      name: dto.name,
      sortOrder: 0, // Not available in DTO
      subjectCount: dto.subjects,
      studentCount: dto.students,
    });
  }

  static levelToDTOList(levels: Level[]): LevelDTO[] {
    return levels.map(l => this.levelToDTO(l));
  }

  static subjectToDTO(subject: Subject): SubjectDTO {
    return {
      id: subject.id,
      levelId: subject.levelId,
      name: subject.name,
      description: subject.description,
      isActive: subject.isActive,
      level: subject.level,
      professor: subject.professor,
      hours: subject.hours,
      modality: subject.modality,
      courseId: subject.courseId,
      isDraft: subject.isDraft,
    };
  }

  static subjectToDomain(dto: SubjectDTO): Subject {
    return new Subject({
      id: dto.id,
      levelId: dto.levelId,
      name: dto.name,
      description: dto.description,
      isActive: dto.isActive,
      level: dto.level,
      hours: dto.hours,
      teacherName: dto.professor,
      modality: dto.modality,
    });
  }

  static subjectToDTOList(subjects: Subject[]): SubjectDTO[] {
    return subjects.map(s => this.subjectToDTO(s));
  }

  static assignmentToDTO(assignment: Assignment): AssignmentDTO {
    return {
      id: assignment.id,
      subjectId: assignment.subjectId,
      subjectName: assignment.subjectName,
      professor: assignment.professor,
    };
  }

  static assignmentToDomain(dto: AssignmentDTO): Assignment {
    return new Assignment(dto);
  }

  static assignmentToDTOList(assignments: Assignment[]): AssignmentDTO[] {
    return assignments.map(a => this.assignmentToDTO(a));
  }
}
